import React from "react";

import "./Select.css";

function Select({value, setValue, options, style}) {
    return (
        <select style={{width: "100%", ...style}} value={value} onChange={(e) => setValue(e.target.value)}>
            {options.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
        </select>
    );
}

export default Select;